import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { compose, onlyUpdateForKeys } from 'recompose';
import { FieldTitle, translate } from 'admin-on-rest';
import { formValueSelector, Field } from 'redux-form';
import { connect } from 'react-redux';

const getStyles = (muiTheme) => {
  const {
    baseTheme,
    textField: { floatingLabelColor, backgroundColor },
  } = muiTheme;

  return {
    labelContainer: {
      fontSize: 16,
      lineHeight: '24px',
      display: 'inline-block',
      position: 'relative',
      backgroundColor,
      fontFamily: baseTheme.fontFamily,
      cursor: 'auto',
      marginTop: 14,
    },
    label: {
      color: floatingLabelColor,
      lineHeight: '22px',
      zIndex: 1,
      transform: 'scale(0.75)',
      transformOrigin: 'left top',
      pointerEvents: 'none',
      userSelect: 'none',
    },
  };
};

export class SyncIdBuilderComponent extends Component {
  handleActivateSync = (event, isChecked, props) => {
    const { input: { onChange } } = props;
    const value = `${event.target.value}`;
    if (isChecked) {
      onChange(value);
    } else {
      onChange('');
    }
  };
  handleCheck = (event, isChecked, props) => {
    const { input: { value, onChange } } = props;
    const values = value.split(':');

    if (isChecked) {
      values.push(event.target.value);
      onChange(values.join(':'));
    } else {
      onChange(values.filter((v) => v !== event.target.value).join(':'));
    }
  };

  Checkboxes = (props) => {
    const {
      formData: { name, wsabId },
      input: { value },
      options,
      translate, // eslint-disable-line
    } = props;

    return (
      <div key="stuff">
        <Checkbox
          key="sync-checkbox"
          disabled={!wsabId || wsabId === 'cdc'}
          checked={!!value}
          onCheck={(event, isChecked) => this.handleActivateSync(event, isChecked, props)}
          value={wsabId && `${name}:${wsabId}`}
          label={translate('activateSync')}
          {...options}
        />
        <Checkbox
          key="mat-checkbox"
          disabled={!value || !wsabId || wsabId === 'cdc'}
          checked={/mat/.test(value)}
          onCheck={(event, isChecked) => this.handleCheck(event, isChecked, props)}
          value="mat"
          label={translate('food')}
          {...options}
        />
        <Checkbox
          key="dryck-checkbox"
          disabled={!value || !wsabId || wsabId === 'cdc'}
          checked={/dryck/.test(value)}
          onCheck={(event, isChecked) => this.handleCheck(event, isChecked, props)}
          value="dryck"
          label={translate('drink')}
          {...options}
        />
        {value}
      </div>
    );
  };

  render() {
    const {
      isRequired,
      label,
      muiTheme,
      resource,
      source,
    } = this.props;
    const muiStyles = getStyles(muiTheme);
    const { prepareStyles } = muiTheme;

    return (
      <div>
        <div style={prepareStyles(muiStyles.labelContainer)}>
          <div style={prepareStyles(muiStyles.label)}>
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          </div>
        </div>
        <Field name={source} component={(props) => <this.Checkboxes {...props} {...this.props} />} />
      </div>
    );
  }
}

SyncIdBuilderComponent.propTypes = {
  addField: PropTypes.bool,
  label: PropTypes.string,
  source: PropTypes.string,
  options: PropTypes.object,
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
  }),
  isRequired: PropTypes.bool,
  resource: PropTypes.string,
  translate: PropTypes.func.isRequired,
  translateChoice: PropTypes.bool,
  muiTheme: PropTypes.object.isRequired,
};

SyncIdBuilderComponent.defaultProps = {
  addField: true,
  options: {},
  translateChoice: true,
};

const enhance = compose(
  onlyUpdateForKeys(['input', 'choices', 'formData']),
  translate,
  muiThemeable()
);

const SyncIdBuilder = enhance(SyncIdBuilderComponent);

const selector = formValueSelector('record-form');

SyncIdBuilder.propTypes = {};

SyncIdBuilder.defaultProps = {
  addField: true,
};

export default connect((state) => ({ formData: { name: selector(state, 'name'), wsabId: selector(state, 'extOrderData.externalId') } }))(SyncIdBuilder);
